import {useUserStore} from '@cohort/wallet/hooks/stores/user';
import {useMerchantContext} from '@cohort/wallet/hooks/useMerchantContext';
import useShopify from '@cohort/wallet/hooks/useShopify';
import {Fragment} from 'react';
import {Navigate, Outlet, useLocation} from 'react-router-dom';
import {shallow} from 'zustand/shallow';

type ProtectedRoutesProps = {
  loginPath: string;
};

const ProtectedRoutes: React.FC<ProtectedRoutesProps> = ({loginPath}) => {
  const merchant = useMerchantContext();
  const {isLoggedIn, isAuthenticating} = useUserStore(
    store => ({
      isLoggedIn: store.isLoggedIn,
      isAuthenticating: store.isAuthenticating,
    }),
    shallow
  );
  const shopify = useShopify();
  const {search, pathname} = useLocation();

  if (isAuthenticating) {
    return <Fragment />;
  }

  if (!isLoggedIn) {
    if (shopify.active) {
      shopify.signInRedirect();
      return;
    }

    if (merchant.redirectLoginUrl !== null) {
      const url = new URL(merchant.redirectLoginUrl);

      url.searchParams.set('cohortRedirect', pathname + search);
      Object.assign(document.createElement('a'), {target: '_parent', href: url}).click();
      return;
    }
    const destinationPath = encodeURIComponent(`${location.pathname}${location.search}`);

    return <Navigate to={`${loginPath}?destinationPath=${destinationPath}`} replace />;
  }
  return <Outlet />;
};

export default ProtectedRoutes;
